import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import SurveyListApiRequest from "../request/SurveyListApiRequest";
import SurveyListApiResponse from "../model/SurveyListApiResponse";

const SurveyListApiService = async (request: SurveyListApiRequest): Promise<SurveyListApiResponse> => {
  const url = "/forms/";
  const { data } = await axios.get(url, { params: request });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useListSurveyApiService = (request: SurveyListApiRequest) =>
  useQuery<Promise<SurveyListApiResponse>, AxiosError, SurveyListApiResponse>(
    ["ListSurveyApiService", request.page], () =>
      SurveyListApiService(request), { keepPreviousData: true }
  );

export default useListSurveyApiService;